import constants from '@/app-configs/constants'

export default [
  {
    path: '/adminsettings',
    name: 'adminsettings',
    component: () => import('@/views/adminsettings/AdminSettings.vue'),
    meta: {
      pageTitle: 'DEBTIA_ADMIN_SETTINGS',
      breadcrumb: [
        {
          text: 'DEBTIA_ADMIN_SETTINGS',
          active: true,
        },
      ],
      action: constants.action.permissionLogin,
      resource: constants.resource.user,
    },
  },
]
